import { useState } from 'react';
import useReactRouter from 'use-react-router';
import { createContainer } from 'unstated-next';

import { RxOrder, RxLensData, Status, RxOrderRequest, RxOrderStatusEnum, Color, ColorsApi, RxOrdersApi, Configuration, ColorType, Option, OptionsApi, GetRxOrderStatusListRequest } from 'openapi';

export default createContainer(() => {

    const [rxOrders, setRxOrders] = useState<RxOrder[]>([]);
    const [colors, setColors] = useState<Color[]>([]);
    const [leftOptions, setLeftOptions] = useState<Option[]>([]);
    const [rightOptions, setRightOptions] = useState<Option[]>([]);

    const { history } = useReactRouter();

    const [isEditing, setIsEditing] = useState(false);
    const [isNewRow, setIsNewRow] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const [selectedOrderId, setSelectedOrderId] = useState<number>(-1);


    const load = async (recordedDate: Date) => {
        try {
            const response = await new RxOrdersApi(new Configuration({
                basePath: process.env.REACT_APP_API_PATH,
                accessToken: localStorage.getItem('token') as string,
            })).getRxOrders({ recordedDate });

            setRxOrders(response);

        } catch (err) {
            if (err.status === 401) {
                history.push('/users/login');
            }
        }
    };

    const create = async (rxLensData: RxLensData) => {
        try {
            rxLensData.leftMeganetLensMasterId = Number(rxLensData.leftMeganetLensMasterId);
            rxLensData.rightMeganetLensMasterId = Number(rxLensData.rightMeganetLensMasterId);
            rxLensData.leftPd = Number(rxLensData.leftPd);
            rxLensData.leftSph = Number(rxLensData.leftSph);
            rxLensData.leftCyl = Number(rxLensData.leftCyl);
            rxLensData.leftAx = Number(rxLensData.leftAx);
            rxLensData.leftAdd = Number(rxLensData.leftAdd);
            rxLensData.leftOutDia = Number(rxLensData.leftOutDia);
            rxLensData.rightPd = Number(rxLensData.rightPd);
            rxLensData.rightSph = Number(rxLensData.rightSph);
            rxLensData.rightCyl = Number(rxLensData.rightCyl);
            rxLensData.rightAx = Number(rxLensData.rightAx);
            rxLensData.rightAdd = Number(rxLensData.rightAdd);
            rxLensData.rightOutDia = Number(rxLensData.rightOutDia);
            rxLensData.meganetColorDensityMappingId = Number(rxLensData.meganetColorDensityMappingId);
            if (rxLensData.leftOptionItemIds !== undefined) {
                rxLensData.leftOptionItemIds.map(e => e.meganetOptionItemId = Number(e.meganetOptionItemId));
                rxLensData.leftOptionItemIds.map(e => e.meganetOptionMasterId = Number(e.meganetOptionMasterId));
            }
            if (rxLensData.rightOptionItemIds !== undefined) {
                rxLensData.rightOptionItemIds.map(e => e.meganetOptionItemId = Number(e.meganetOptionItemId));
                rxLensData.rightOptionItemIds.map(e => e.meganetOptionMasterId = Number(e.meganetOptionMasterId));
            }

            const response = await new RxOrdersApi(new Configuration({
                basePath: process.env.REACT_APP_API_PATH,
                accessToken: localStorage.getItem('token') as string,
            })).createRxOrder({ rxLensData });

            setRxOrders([...rxOrders, { ...response, ...rxLensData, status: RxOrderStatusEnum.Waiting }]);
        } catch (err) {
            if (err.status === 401) {
                history.push('/users/login');
            }
        }
    };

    const update = async (newRxOrder: RxOrder) => {
        try {
            newRxOrder.leftPd = Number(newRxOrder.leftPd);
            newRxOrder.leftSph = Number(newRxOrder.leftSph);
            newRxOrder.leftCyl = Number(newRxOrder.leftCyl);
            newRxOrder.leftAx = Number(newRxOrder.leftAx);
            newRxOrder.leftAdd = Number(newRxOrder.leftAdd);
            newRxOrder.leftOutDia = Number(newRxOrder.leftOutDia);
            newRxOrder.rightPd = Number(newRxOrder.rightPd);
            newRxOrder.rightSph = Number(newRxOrder.rightSph);
            newRxOrder.rightCyl = Number(newRxOrder.rightCyl);
            newRxOrder.rightAx = Number(newRxOrder.rightAx);
            newRxOrder.rightAdd = Number(newRxOrder.rightAdd);
            newRxOrder.rightOutDia = Number(newRxOrder.rightOutDia);
            newRxOrder.meganetColorDensityMappingId = Number(newRxOrder.meganetColorDensityMappingId);
            if (newRxOrder.leftOptionItemIds !== undefined) {
                newRxOrder.leftOptionItemIds.map(e => e.meganetOptionItemId = Number(e.meganetOptionItemId));
                newRxOrder.leftOptionItemIds.map(e => e.meganetOptionMasterId = Number(e.meganetOptionMasterId));
            }
            if (newRxOrder.rightOptionItemIds !== undefined) {
                newRxOrder.rightOptionItemIds.map(e => e.meganetOptionItemId = Number(e.meganetOptionItemId));
                newRxOrder.rightOptionItemIds.map(e => e.meganetOptionMasterId = Number(e.meganetOptionMasterId));
            }

            await new RxOrdersApi(new Configuration({
                basePath: process.env.REACT_APP_API_PATH,
                accessToken: localStorage.getItem('token') as string,
            })).updateRxOrder({ meganetLensRxOrderId: newRxOrder.meganetLensRxOrderId, rxLensData: newRxOrder as RxLensData });

            setRxOrders(rxOrders => {
                let index = rxOrders.findIndex(rxOrder => rxOrder.meganetLensRxOrderId === newRxOrder.meganetLensRxOrderId);
                return [...rxOrders.slice(0, index), newRxOrder, ...rxOrders.slice(index + 1)];
            });
        } catch (err) {
            if (err.status === 401) {
                history.push('/users/login');
            }
        }
    };

    const remove = async (meganetLensRxOrderId: number) => {
        try {
            await new RxOrdersApi(new Configuration({
                basePath: process.env.REACT_APP_API_PATH,
                accessToken: localStorage.getItem('token') as string,
            })).deleteRxOrder({ meganetLensRxOrderId });

            setRxOrders(rxOrders => {
                let index = rxOrders.findIndex(rxOrder => rxOrder.meganetLensRxOrderId === meganetLensRxOrderId);
                return [...rxOrders.slice(0, index), ...rxOrders.slice(index + 1)];
            })

        } catch (err) {
            if (err.status === 401) {
                history.push('/users/login')
            }
        }
    };

    const order = async (rxOrderRequest: RxOrderRequest) => {
        try {
            await new RxOrdersApi(new Configuration({
                basePath: process.env.REACT_APP_API_PATH,
                accessToken: localStorage.getItem('token') as string,
            })).requestRxOrders({ rxOrderRequest });

            let requestId = rxOrderRequest.requests.meganetLensRxOrderId;

            setRxOrders(rxOrders => {

                let newRxOrders = rxOrders.slice();

                newRxOrders.forEach(rxOrder => {
                    if (requestId !== undefined) {
                        if (requestId === rxOrder.meganetLensRxOrderId) {
                            rxOrder.status = RxOrderStatusEnum.Requesting;
                        }
                    }
                })

                return newRxOrders;
            });
        } catch (err) {
            if (err.status === 401) {
                history.push('/users/login');
            }
        }
    };

    const getStatusList = async (meganetLensRxOrderId?: number, status?: number) => {
        try {
            var results = await new RxOrdersApi(new Configuration({
                basePath: process.env.REACT_APP_API_PATH,
                accessToken: localStorage.getItem('token') as string,
            })).getRxOrderStatusList({ meganetLensRxOrderId, status });
            return results.map(res => {
                return { ...res, orderType: 1 }
            });
        } catch (err) {
            if (err.status === 401) {
                history.push('/users/login');
            }
        }
    }

    //#region Colors
    const loadColors = async () => {
        try {
            const response = await new ColorsApi(new Configuration({
                basePath: process.env.REACT_APP_API_PATH,
                accessToken: localStorage.getItem('token') as string,
            })).getColors({});

            setColors(response);

        } catch (err) {
            if (err.status === 401) {
                history.push('/users/login');
            }
        }
    };

    const getColorByColorDensityMappingId = (meganetColorDensityMappingId: number | undefined): Color | undefined => {
        var color = undefined;
        if (meganetColorDensityMappingId !== undefined) {
            color = colors.find(color => color.meganetColorDensityMappingId === meganetColorDensityMappingId);
        }
        return color ? color : undefined;
    };

    const getFilteredColors = () => {
        return colors.reduce((previous: any, current: any) => {
            const color = previous.find((color: Color) => color.meganetColorId === current.meganetColorId);

            if (!color) {
                previous.push({
                    meganetColorDensityMappingId: current.meganetColorDensityMappingId,
                    meganetColorGroupId: current.meganetColorGroupId,
                    meganetColorId: current.meganetColorId,
                    colorCode: current.colorCode,
                    colorName: current.colorName,
                    colorNameEnglish: current.colorNameEnglish,
                })
            }

            return previous;
        }, []);
    }

    const getColorByMeganetColorId = (meganetColorId: number): Color[] => {
        var results = colors.filter(color => color.meganetColorId === meganetColorId)
            .reduce((previous: Color[], current: Color) => {
                var color = previous.find(color => color.meganetColorTypeId === current.meganetColorTypeId);

                if (!color) {
                    previous.push(current);
                }

                return previous;
            }, []);
        return results;
    }

    const getColorTypeByMeganetColorId = (meganetColorId: number): ColorType[] => {
        return colors.filter(color => color.meganetColorId === meganetColorId)
            .reduce((previous: any[], current: any) => {
                var color = previous.find(color => color.meganetColorTypeId === current.meganetColorTypeId);

                if (!color) {
                    previous.push(current);
                }

                return previous;
            }, []);
    }

    const getDensityByMeganetColorTypeId = (meganetColorId: number, meganetColorTypeId: number): any[] => {
        var filteredColors = colors.filter(color => color.meganetColorId === meganetColorId)
            .filter(color => color.meganetColorTypeId === meganetColorTypeId)

        const densityDetails: any[] = [];
        filteredColors.map(color => {
            const density = {
                meganetDensityId: color.meganetDensityId,
                denCode: color.denCode,
                denTop: color.denTop,
                denBottom: color.denBottom,
                density: `${color.denTop}${color.denBottom !== null ? '/' + color.denBottom : ''}`
            }
            densityDetails.push(density);
        })
        return densityDetails;
    }

    const getMeganetColorDensityMappingId = (meganetColorId: number, meganetColorTypeId: number, meganetDensityId: number): number | undefined => {
        var results = undefined;
        if (meganetColorId !== -1 || meganetColorTypeId !== -1 || meganetDensityId !== -1) {
            results = colors.filter(color => color.meganetColorId === meganetColorId)
                .filter(color => color.meganetColorTypeId === meganetColorTypeId)
                .filter(colorType => colorType.meganetDensityId === meganetDensityId);

        }
        return results ? results[0].meganetColorDensityMappingId : undefined;
    }

    //#endregion

    //#region Option
    const loadOptions = async (meganetLensMasterId: number, leftRight?: number) => {
        try {
            const response = await new OptionsApi(new Configuration({
                basePath: process.env.REACT_APP_API_PATH,
                accessToken: localStorage.getItem('token') as string,
            })).getOptions({ meganetLensMasterId });

            if (leftRight === 0) {
                setLeftOptions(response);
            } else if (leftRight === 1) {
                setRightOptions(response);
            } else {
                setLeftOptions(response);
                setRightOptions(response);
            }

        } catch (err) {
            if (err.status === 401) {
                history.push('/users/login');
            }
        }
    };

    const getOptionsByLeftLensMasterId = (leftMeganetLensMasterId: number): Option[] => {
        return leftOptions.filter(option => option.meganetLensMasterId === leftMeganetLensMasterId).
            reduce((previous: any, current: any) => {
                const option = previous.find((option: Option) => option.meganetOptionMasterId === current.meganetOptionMasterId);

                if (!option) {
                    previous.push({
                        meganetLensOptionItemMappingId: current.meganetLensOptionItemMappingId,
                        meganetLensMasterId: current.meganetLensMasterId,
                        meganetOptionMasterId: current.meganetOptionMasterId,
                        optionCode: current.optionCode,
                        optionName: current.optionName,
                        leftRight: 0
                    })
                }

                return previous;
            }, []);
    }

    const getOptionsByRightLensMasterId = (rightMeganetLensMasterId: number): Option[] => {
        var result = rightOptions.filter(option => option.meganetLensMasterId === rightMeganetLensMasterId).
            reduce((previous: any, current: any) => {
                const option = previous.find((option: Option) => option.meganetOptionMasterId === current.meganetOptionMasterId);

                if (!option) {
                    previous.push({
                        meganetLensOptionItemMappingId: current.meganetLensOptionItemMappingId,
                        meganetLensMasterId: current.meganetLensMasterId,
                        meganetOptionMasterId: current.meganetOptionMasterId,
                        optionCode: current.optionCode,
                        optionName: current.optionName,
                        leftRight: 1
                    })
                }

                return previous;
            }, []);

        return result;
    }

    const getLeftOptionItemByOptionMasterId = (leftMeganetLensMasterId: number, meganetOptionMasterId: number) => {
        return leftOptions.filter(option => option.meganetLensMasterId === leftMeganetLensMasterId).
            filter(optionItem => optionItem.meganetOptionMasterId === meganetOptionMasterId);
    }

    const getRightOptionItemByOptionMasterId = (rightMeganetLensMasterId: number, meganetOptionMasterId: number) => {
        return rightOptions.filter(option => option.meganetLensMasterId === rightMeganetLensMasterId)
            .filter(optionItem => optionItem.meganetOptionMasterId === meganetOptionMasterId);
    }

    //#endregion

    return {
        rxOrders, setRxOrders, load, create, update, remove, order,
        setIsEditing, isEditing, setIsDeleting, isDeleting, selectedOrderId, setSelectedOrderId, isNewRow, setIsNewRow,
        loadColors, colors, getColorByColorDensityMappingId, getFilteredColors,
        getDensityByMeganetColorTypeId, getColorByMeganetColorId, getColorTypeByMeganetColorId, getMeganetColorDensityMappingId,
        loadOptions, getOptionsByLeftLensMasterId, getOptionsByRightLensMasterId,
        getLeftOptionItemByOptionMasterId, getRightOptionItemByOptionMasterId,
        getStatusList
    };
})